import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

// Gates every supervisor-side transport surface (the /transport page and nav
// item, the shift dialogs' transport field, the shift details line) on the
// company add-on `transportEnabled`.
const useTransportEnabled = (): boolean => {
	return useSelector(
		(state: StoreType) => state.user?.userData?.transportEnabled === true
	);
};

export default useTransportEnabled;
